import LayoutBlank from '@/layout/LayoutBlank'

export default [{
  path: '/',
  component: LayoutBlank,
  children: [{
    path: 'login',
    component: () => import('@/components/Login'),
    meta: { unAuth: true }
  }, {
    path: 'requestresetpassword',
    component: () => import('@/components/unauthenticated/RequestResetPassword'),
    meta: { unAuth: true }
  }, {
    path: 'resetpassword/:id',
    component: () => import('@/components/unauthenticated/ResetPassword'),
    meta: { unAuth: true }
  }, {
    path: 'changepassword/:id',
    component: () => import('@/components/unauthenticated/ChangePassword'),
    meta: { unAuth: true }
  }, {
    path: 'resetpasswordconfirmation',
    component: () => import('@/components/unauthenticated/ResetPasswordConfirmation'),
    meta: { unAuth: true }
  }, {
    path: 'changepasswordconfirmation',
    component: () => import('@/components/unauthenticated/ChangePasswordConfirmation'),
    meta: { unAuth: true }
  }, {
    path: 'requestresetpasswordconfirmation',
    component: () => import('@/components/unauthenticated/RequestResetPasswordConfirmation'),
    meta: { unAuth: true }
  }, {
    path: 'loggedoutinactivity',
    component: () => import('@/components/unauthenticated/LoggedOutInactivity'),
    meta: { unAuth: true }
  }, {
    path: 'two-factor-verify',
    component: () => import('@/components/unauthenticated/TwoFactorVerify'),
    meta: { unAuth: true }
  }, {
    path: 'two-factor-setup',
    component: () => import('@/components/unauthenticated/TwoFactorSetup'),
    meta: { unAuth: true }
  }, {
    path: 'menuedit/:id',
    component: () => import('@/components/unauthenticated/menuitems/menuEdit'),
    meta: { unAuth: true }
  }, {
    path: 'menulist',
    component: () => import('@/components/unauthenticated/menuitems/menuList'),
    meta: { unAuth: true }
  }, {
    path: 'confirmation',
    component: () => import('@/components/authenticated/Confirmation')
  }]
}]
